import {
    BAD_RESPONSE_DELETE_SOLICITOR_GROUP, CHANGE_FIELD,
    CHANGE_SOLICITOR_GROUP_LIST_SETTINGS, CREATED_SOLICITOR_GROUP_RESPONSE, FAILED_TO_GET_SOLICITOR_GROUPS,
    RECEIVE_DELETE_SOLICITOR_GROUP,
    RECEIVE_GET_SPECIFIC_SOLICITOR_GROUP,
    RECEIVE_GET_UNDERWRITERS, RECEIVE_GET_WORK_SOURCES, RECEIVE_SOLICITOR_GROUPS, RECEIVE_SOLICITOR_GROUPS_SUGGESTIONS,
    REQUEST_DELETE_SOLICITOR_GROUP,
    REQUEST_GET_SOLICITOR_GROUPS, SOLICITOR_GROUP_PAGE_SHIFT
} from "../actions/index";

const defaultState = {
	solicitorGroups: [],
	underwriters: [],
	workSources: [],
	fetching:false,
	selectedGroup: {},
	page:1,
	totalBoxes: 1,
	selectedView:20,
	suggestions: [],
	selectedSuggestions: [],
	value:'',
	deleting:false,
	openModal:false,
	totalRecords: 0
};

export default (state = defaultState, action) => {
	switch (action.type) {
		case RECEIVE_GET_SPECIFIC_SOLICITOR_GROUP:
			if(!action.payload) {
				return state;
			}
			return {
				...state,
				selectedGroup: action.payload.name,
			};
		case CHANGE_FIELD:
			return {
				...state,
				openModal:false
			};
		case CREATED_SOLICITOR_GROUP_RESPONSE:
			return {
				...state,
				openModal: false
			};
		case REQUEST_DELETE_SOLICITOR_GROUP:
			return {
				...state,
				deleting: true
			};
		case RECEIVE_DELETE_SOLICITOR_GROUP:
			return {
				...state,
				deleting:false
			};
		case BAD_RESPONSE_DELETE_SOLICITOR_GROUP:
			return {
				...state,
				deleting:false
			};
		case SOLICITOR_GROUP_PAGE_SHIFT:
			if (action.payload.direction === 'left' && state.page > 1)
				return {
					...state,
					page: state.page - 1,
					// totalBoxes: action.payload.totalPaginationBoxes
				};
			else if (action.payload.direction === 'right' && state.page < state.totalBoxes)
				return {
					...state,
					page: state.page + 1,
					// totalBoxes: action.payload.totalPaginationBoxes
				};
			else return {
					...state,
					// totalBoxes: action.payload.totalPaginationBoxes
				};
		case CHANGE_SOLICITOR_GROUP_LIST_SETTINGS:
			if (action.payload.key === 'selectedView') {
				let totalDisplayBoxes = Math.ceil(state.solicitorGroups.length / parseInt(action.payload.value));
				return {
					...state,
					selectedView: action.payload.value,
					// totalBoxes: totalDisplayBoxes,
					page: 1
				}
			}
			else if (action.payload.key === 'selectedSuggestions') {
				return {
					...state,
					selectedSuggestions: action.payload.value,
					selectedStatus: '',
					page: 1
				}
			}
			return {
				...state,
				[action.payload.key] : action.payload.value
			};
		case RECEIVE_GET_UNDERWRITERS:
			return {
				...state,
				underwriters: action.payload
			};
		case RECEIVE_GET_WORK_SOURCES:
			return {
				...state,
				workSources: action.payload
			};
		case REQUEST_GET_SOLICITOR_GROUPS:
			return {
				...state,
				fetching: true
			};
		case RECEIVE_SOLICITOR_GROUPS:
			let totalDisplayBoxes = Math.ceil(action.payload.totalRecords / parseInt(state.selectedView));
			let currentPage = state.page;
			if(state.page > totalDisplayBoxes && totalDisplayBoxes !== 0){
				currentPage = totalDisplayBoxes;
			}
			return {
				...state,
				solicitorGroups:action.payload.data,
				fetching: false,
				page: currentPage,
				totalBoxes: totalDisplayBoxes,
				totalRecords: action.payload.totalRecords
			};
		case FAILED_TO_GET_SOLICITOR_GROUPS:
			return {
				...state,
				fetching: false
			};
		case RECEIVE_SOLICITOR_GROUPS_SUGGESTIONS:
			return {
				...state,
				suggestions: action.payload.data
			};
		case '@@router/LOCATION_CHANGE':
			if (action.payload.location.pathname.includes('/solicitors/solicitor-groups/edit-solicitor-group'))
				return {
					...defaultState,
					selectedGroup: state.selectedGroup,
					solicitorGroups: state.solicitorGroups,
					underwriters: state.underwriters,
					workSources: state.workSources,
					page:state.page,
					totalBoxes: state.totalBoxes,
					selectedView:state.selectedView
				};
			else return {
				...defaultState,
				solicitorGroups: state.solicitorGroups,
				underwriters: state.underwriters,
				workSources: state.workSources,
				page:state.page,
				totalBoxes: state.totalBoxes,
				selectedView:state.selectedView
			};
		default :
			return state
	}
}